import { render } from "./ChartRadar.vue?vue&type=template&id=5fc2c0bc"
import script from "./ChartRadar.vue?vue&type=script&lang=js"
export * from "./ChartRadar.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__